import { useState } from 'react';
import { useQuery } from '@/helpers/useQuery';
import { Link } from 'react-router-dom';

import Document from '@/app/document/Document';
import DocumentUploader from '@/app/document/DocumentUploader';
import { DOCUMENT_TYPE } from '@/app/document/enums';

import Error from '@/components/common/Error';
import { Button } from '@/components/ui/button';

import { useDeleteDocument } from '@/data/document';
import { useCoachSelf } from '@/data/coach';
import { useApplication } from '@/data/application';

const APPLICATION_STEP_KEY = 'first-aid';

const FirstAidForm = () => {
  const coachSelf = useCoachSelf();
  const [apiError, setApiError] = useState();
  const deleteDocument = useDeleteDocument();
  const coachActivityId = useQuery('coachActivityId');
  const applicationStructure = useApplication({ coachActivityId });

  const step = applicationStructure.data.steps.find(
    (step) => step.key === APPLICATION_STEP_KEY
  );

  const handleDeleteDocument = async (id) => {
    try {
      setApiError('');
      await deleteDocument(id);
      coachSelf.mutate();
      applicationStructure.mutate();
    } catch (err) {
      setApiError(err.message);
    }
  };

  const handleUploadSuccess = async () => {
    coachSelf.mutate();
    applicationStructure.mutate();
  };

  const documents = coachSelf.data.documents.filter(
    (doc) => doc.type === DOCUMENT_TYPE.FIRST_AID
  );

  return (
    <div className="py-4">
      <h4>Documents</h4>
      {documents.map((doc) => (
        <Document key={doc.id} doc={doc} onDelete={handleDeleteDocument} />
      ))}
      <div className="flex justify-center py-8">
        <DocumentUploader
          setApiError={setApiError}
          ownerObj={{ coachId: coachSelf.data.id }}
          onSuccess={handleUploadSuccess}
          documentType={DOCUMENT_TYPE.FIRST_AID}
        />
      </div>
      {apiError && <Error error={apiError} />}
      <div className="flex justify-end">
        <Link
          to={step.nextStepLink}
          disabled={coachSelf.data.documents.length === 0}
        >
          <Button disabled={documents.length === 0}>Continue</Button>
        </Link>
      </div>
    </div>
  );
};

export default FirstAidForm;
